"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNumber = void 0;
const character_1 = require("./character");
const skip_1 = require("./skip");
const Error_1 = require("./Error");
const getNumber = (input, start) => {
    const end = (0, skip_1.skip)(input, start, character_1.isNumberStart);
    const literal = input.slice(start, end);
    const parts = literal.split('.');
    if (parts.length <= 2 && /^-?(?:[1-9]\d*|0)?$/.test(parts[0])) {
        return {
            start,
            end,
            value: Number(literal),
        };
    }
    throw new Error_1.$Error('InvalidNumber', literal);
};
exports.getNumber = getNumber;
